<template>
  <div>
    <Tooltip class='text' :style='{color:statusCode == "leave" ? "#c3cbd6" : "#464c5b",fontWeight:"900"}' :delay="1200" :content="name">
      {{name}}
    </Tooltip>

    <div :style="{background:bgColor}" class='tagStyle' >
        {{ statusName }}
    </div>
  </div>
</template>
<script>
  export default {
    props:[
      'statusCode',
      'name',
      'isDepartmentManager',
      'channel'
    ],
    data(){
      return {
        bgColor: "#fff"
      }
    },
    computed: {

      statusName: {
          get () {
               if (this.statusCode == "unactivated") {
                  this.bgColor = "#f6f6f6"
                  return this.channel == "invited" ? "申请加入" : "未激活"
               }

              if (this.statusCode == "leave") {
                  this.bgColor = "#f6f6f6"
                  return "离职"
               }

               if (this.statusCode == "transfer") {
                  this.bgColor = "#F56C6C"
                  return "交接中"
               }

               if (this.isDepartmentManager) {
                  this.bgColor = "#FF943e"
                  return "主管"
               }
          }
      }
    },
  }
</script>
<style scoped>
  .text {
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tagStyle {
    float: right;
    width:55px;
    border-radius:4px;
  }
</style>
